<div class="form-dialog" style="min-width:890px;">
  <h1>Edit {{title}}
    <div (click)="showing_hints=!showing_hints">
      @if (showing_hints) {
        Hide hints
      }
      @if (!showing_hints) {
        Show hints
      }
    </div>
  </h1>
  @if (component.data.type === 'process') {
    <flowchart-process-form (close_event)="onCloseClick()"
      (save_event)="save($event)"
      [component]="component"
      [dialog]=true
      [flowchart]="flowchart"
      [show_hints]="showHints">
    </flowchart-process-form>
  }
  @if (component.data.type === 'stream') {
    <flowchart-stream-form (close_event)="onCloseClick()"
      (save_event)="save($event)"
      [component]="component"
      [dialog]=true
      [flowchart]="flowchart"
      [show_hints]="showHints">
    </flowchart-stream-form>
  }
  @if (component.data.type === 'equipment') {
    <flowchart-equipment-form (close_event)="onCloseClick()"
      (save_event)="save($event)"
      [component]="component"
      [dialog]=true
      [flowchart]="flowchart"
      [show_hints]="showHints">
    </flowchart-equipment-form>
  }
  @if (component.data.type === 'image') {
    <flowchart-image-form (close_event)="onCloseClick()"
      (save_event)="save($event)"
      [component]="component"
      [dialog]=true
      [flowchart]="flowchart"
      [show_hints]="showHints">
    </flowchart-image-form>
  }
</div>
